<template>
  <div class="sort-dropdown d-flex align-center">
    <div class="sort-dropdown__label-wrapper">
      <label class="sort-dropdown__label" :for="id">
        {{ label }}
      </label>
    </div>
    <div class="sort-dropdown__select-wrapper">
      <select
        :id="id"
        v-model="selectedSort"
        class="sort-dropdown__select"
        @change="sortChanged"
        @click="onClick"
        @blur="onBlur"
        @keydown.space="onKeydownSpace"
      >
        <option
          v-for="(option, index) of sortOptions"
          :key="index"
          :value="option.key"
        >
          {{ option.name }}
        </option>
      </select>
      <OpenIndicatorArrowIcon
        class="sort-dropdown__icon"
        :class="{ 'sort-dropdown__icon--rotated': isIconRotated }"
      />
    </div>
  </div>
</template>

<script>
import OpenIndicatorArrowIcon from "~/components/combobox/icons/OpenIndicatorArrowIcon.vue";

export default {
  name: "SortDropdown",
  components: {
    OpenIndicatorArrowIcon,
  },
  props: {
    id: { type: String, default: "sortByDropdown" },
    label: { type: String, default: "Sort by" },
    name: { type: String, required: true },
    sortOptions: { type: Array, required: true },
    defaultSort: { type: String, required: true },
  },
  data() {
    return {
      selectedSort: this.defaultSort,
      isIconRotated: false,
    };
  },
  methods: {
    sortChanged() {
      this.isIconRotated = false;
      this.$emit("sortChanged", this.selectedSort);
    },
    onClick() {
      this.isIconRotated = !this.isIconRotated;
    },
    onBlur() {
      this.isIconRotated = false;
    },
    onKeydownSpace() {
      this.isIconRotated = true;
    },
  },
};
</script>

<style lang="scss">
.sort-dropdown {
  @media only screen and (max-width: 600px) {
    width: 100%;
  }

  &__label-wrapper {
    margin-right: 20px;
  }

  &__label {
    font-size: 1.25rem;

    @media only screen and (max-width: 600px) {
      font-weight: 700;
      margin-right: 20px;
      width: 100%;
      color: var(--v-primary-base);
    }
  }
  &__select-wrapper {
    position: relative;
    display: inline-block;

    @media only screen and (max-width: 600px) {
      width: 100%;
    }
  }
  &__select {
    width: 160px;
    height: 50px;

    border: 1px solid;
    border-radius: 4px;
    padding-left: 10px;
    padding-right: 10px;
    cursor: pointer;
    background-color: var(--v-inverted-base);

    @media only screen and (max-width: 600px) {
      font-weight: 700;
      font-size: 1.25rem;
      color: var(--v-primary-base);
      caret-color: var(--v-primary-base);
      border-color: var(--v-primary-base);
      width: 100%;
    }
  }
  &__icon {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 14px;
    cursor: pointer;

    &--rotated {
      transform: translateY(-50%) rotate(180deg);
    }

    @media only screen and (max-width: 600px) {
      color: var(--v-primary-base);
    }
  }
}
</style>
